import { render, staticRenderFns } from "./UpdateClassMenu.vue?vue&type=template&id=bba64d06&scoped=true"
import script from "./UpdateClassMenu.vue?vue&type=script&lang=js"
export * from "./UpdateClassMenu.vue?vue&type=script&lang=js"
import style0 from "./UpdateClassMenu.vue?vue&type=style&index=0&id=bba64d06&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba64d06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bba64d06')) {
      api.createRecord('bba64d06', component.options)
    } else {
      api.reload('bba64d06', component.options)
    }
    module.hot.accept("./UpdateClassMenu.vue?vue&type=template&id=bba64d06&scoped=true", function () {
      api.rerender('bba64d06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentquality/UpdateClassMenu.vue"
export default component.exports